export const replacePathImageForSmall = (path) => {
  return path.replace('/reduced/', '/resized/small/');
};